.header {
  display: grid;
  grid-template-columns: 44px 1fr 130px 70px 110px 90px;
  gap: 14px;
  padding: 0 14px 8px;
  font-family: var(--sans);
  font-weight: 900;
  font-size: 10px;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: var(--mute);
}

.right { text-align: right; }
.center { text-align: center; }
